import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/store';
import olfFeatures from "../olfFeatures";
import { eNavbarTitles } from "../src/util/enums/navbar";

Vue.use(VueRouter);

import Login from "@/pages/Login/Login.vue";
import RequestNewPassword from "@/pages/NewPassword/RequestNewPassword.vue";
import ResetPassword from "@/pages/NewPassword/ResetPassword.vue";
import LogoutSuccessful from "@/pages/Logout/LogoutSuccessful.vue";
import MyCustomers from "@/pages/Views/Seller/MyCustomers.vue";
import MySuppliers from "@/pages/Views/Buyer/MySuppliers.vue";
import PurchaseHistory from "@/pages/Purchase/PurchaseHistory.vue";
import manageProducts from "@/pages/Views/Seller/ManageProducts/ManageProducts.vue";
import OlfChat from "@/pages/Chat/OlfChat.vue";
import NegotiationsSeller from "@/pages/Views/Seller/NegotiationsSeller.vue";
import NegotiationsBuyer from "@/pages/Views/Buyer/NegotiationsBuyer.vue";
import AllPrices from "@/pages/Prices/AllPrices.vue";
import SellerDashboard from "@/pages/Views/Seller/Dashboard/SellerDashboard.vue";
import BuyerDashboard from "@/pages/BuyerDashboard/BuyerDashboard.vue";
import TermsAndConditions from "@/pages/TermsAndConditions.vue";
import MyAccount from "@/pages/Account/MyAccount.vue";
import OrderCapture from "@/pages/Views/Seller/OrderCapture.vue";
import PricingEngine from "@/pages/Views/Seller/PricingEngine.vue";
import ExistingContracts from "@/pages/Contracts/ExistingContracts.vue";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

const router = new VueRouter({
  routes: [
    {
      name: "Login",
      path: "/login",
      components: {
        login: Login,
      },
      meta: {
        style: "login",
        title: "Login",
      },
    },
    {
      name: "LogoutSuccessful",
      path: "/logoutSuccessful",
      components: {
        logoutSuccessful: LogoutSuccessful,
      },
      meta: {
        style: "login",
        title: "Logout",
      },
    },
    {
      name: "RequestNewPassword",
      path: "/requestNewPassword",
      components: {
        requestNewPassword: RequestNewPassword,
      },
      meta: {
        style: "login",
        title: "Request New Password",
      },
    },
    {
      name: "ResetPassword",
      path: "/resetPassword",
      components: {
        resetPassword: ResetPassword,
      },
      meta: {
        style: "login",
        title: "Reset Password",
      },
    },
    {
      name: "TermsAndConditions",
      path: "/termsAndConditions",
      components: {
        TermsAndConditions: TermsAndConditions,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["seller", "buyer"],
        title: "Terms and Conditions",
      },
    },
    {
      name: "MyCustomers",
      path: "/MyCustomers",
      components: {
        MyCustomers: MyCustomers,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["seller"],
        title: eNavbarTitles.manageCustomers,
      },
    },
    {
      name: "MySuppliers",
      path: "/MySuppliers",
      components: {
        MySuppliers: MySuppliers,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["buyer"],
        title: eNavbarTitles.mySellers,
      },
    },
    {
      name: "PurchaseHistory",
      path: "/OrderHistory/:tab?",
      components: {
        PurchaseHistory: PurchaseHistory,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["buyer", "seller"],
        title: eNavbarTitles.orderHistory,
      },
    },
    {
      name: "OrderCapture",
      path: "/OrderCapture/:tab?",
      components: {
        OrderCapture: OrderCapture,
      },
      meta: {
        requiresAuth: true,
        featureRequired: olfFeatures.FEATURE_ORDER_CAPTURE,
        usersAuthorized: ["seller"],
        title: eNavbarTitles.orderCapture,
      },
    },
    {
      name: "PricingEngine",
      path: "/PricingEngine",
      components: {
        PricingEngine: PricingEngine,
      },
      meta: {
        requiresAuth: true,
        featureRequired: olfFeatures.FEATURE_PRICING_ENGINE,
        usersAuthorized: ["seller"],
        title: eNavbarTitles.pricingEngine,
      },
    },
    {
      name: "buyerDashboard",
      path: "/buyerDashboard/:tab?",
      components: {
        buyerDashboard: BuyerDashboard,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["buyer"],
        title: eNavbarTitles.dashboard,
      },
    },
    {
      name: "sellerDashboard",
      path: "/sellerDashboard/:tab?",
      components: {
        sellerDashboard: SellerDashboard,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["seller"],
        title: eNavbarTitles.dashboard,
      },
    },
    {
      name: "manageOffers",
      path: "/manageOffers/:tab?",
      components: {
        manageProducts: manageProducts,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["seller"],
        title: eNavbarTitles.manageOffers,
      },
    },
    {
      name: "AllPrices",
      path: "/AllPrices/:tab?",
      components: {
        AllPrices: AllPrices,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["buyer"],
        title: eNavbarTitles.allPrices,
      },
    },
    {
      name: "NegotiationsBuyer",
      path: "/NegotiationsBuyer",
      components: {
        NegotiationsBuyer: NegotiationsBuyer,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["buyer"],
        title: eNavbarTitles.negotiations,
      },
    },
    {
      name: "NegotiationsSeller",
      path: "/NegotiationsSeller",
      components: {
        NegotiationsSeller: NegotiationsSeller,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["seller"],
        title: eNavbarTitles.negotiations,
      },
    },
    {
      name: "OlfChat",
      path: "/Chat",
      components: {
        OlfChat: OlfChat,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["seller", "buyer"],
        title: eNavbarTitles.olfChat,
      },
    },
    {
      name: "MyAccount",
      path: "/MyAccount",
      components: {
        MyAccount: MyAccount,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["seller", "buyer"],
        title: "Settings",
      },
    },
    {
      name: "ExistingContracts",
      path: "/ExistingContracts",
      components: {
        ExistingContracts: ExistingContracts,
      },
      meta: {
        requiresAuth: true,
        usersAuthorized: ["buyer"],
        title: eNavbarTitles.contracts,
      },
    },
    {
      name: "Dashboard",
      path: "/",
      redirect: () => {
        const userLoggedIn = store.state.login.userLoggedIn;
        if (userLoggedIn && userLoggedIn.category != "") {
          if (localStorage.getItem("terms_accepted") == "true") {
            if (userLoggedIn.category === "seller") return "/sellerDashboard";
            else if (userLoggedIn.category === "buyer") return "/buyerDashboard";
          } else {
            return "/termsAndConditions";
          }
        }
        return "/login";
      },
    },
  ],
});

router.beforeResolve(async (to,from,next)=>{
    // If a route with a title was found, set the document title to that value.
    const closestTitle = to.matched.find(r => r.meta && r.meta.title);
    if (closestTitle){
        document.title = `${closestTitle.meta.title} | Harvest Energy`;
    }

  let session = localStorage.getItem("session");
  if (!session && !to.meta.requiresAuth) {
    next();
  } else if (!session) {
    // no session
    next("login");
    return;
  } else {
    //Bind the session to the store
    let existingSession = JSON.parse(session);
    //Create the user state here... i don't like it.
    const payload = { data: { success: true, user: existingSession } };
    store.commit("login/LOGIN_USER", payload);

    await store.dispatch("login/getAccountMetadata");
    // Ensure we populate the product config in the store
    await store.dispatch("metadata/getMetadataConfig").catch(() => {
      next(false);
      console.log("error: calling dispatch `metadata/getMetadataConfig`");
    });

    await store.dispatch("login/getAccountMetadata");
    // Ensure we populate the product config in the store
    await store.dispatch("metadata/getMetadataConfig").catch(() => {
      next(false);
      console.log("error: calling dispatch `metadata/getMetadataConfig`");
    });

    var userCategory = store.state.login.userLoggedIn.category;
    if (to.matched.some((record) => record.meta.requiresAuth) && to.name !== "TermsAndConditions") {
      if (userCategory) {
        const { usersAuthorized, featureRequired } = to.meta;
        const findMatch = usersAuthorized.find((element) => element === userCategory);
        if (findMatch) {
          /* Take them back to T&C if they haven't accepted it */
          if (localStorage.getItem("terms_accepted") == "true") {
            //success
            store.dispatch("login/updateTermsAcceptedStatus", true);
            // check if necessary feature is enabled for user
            if (featureRequired) {
              if (store.getters["login/getAllAccountFeatures"].includes(featureRequired)) {
                next();
                return;
              } else {
                next("/");
                return;
              }
            }
            next();
            return;
          } else {
            store.dispatch("login/updateTermsAcceptedStatus", false);
            next("/");
            return;
          }
        } else {
          //Needs something to abort tot say error
          next();
          return;
        }
      }
    } else {
      //We are logged in and trying to access the login page for some reason...
      if (
        to.path === "/login" ||
        to.path === "/logoutSuccessful" ||
        to.path === "/resetPassword" ||
        to.path === "/requestNewPassword"
      ) {
        next("/");
        return;
      } else if (
        to.path === "/manageOffers" ||
        to.path === "/ManageOffers" ||
        to.path === "/manageOffers/" ||
        to.path === "/ManageOffers/"
      ) {
        next("/manageOffers/spot");
        return;
      } else if (
        to.path === "/orderHistory" ||
        to.path === "/OrderHistory" ||
        to.path === "/orderHistory/" ||
        to.path === "/OrderHistory/"
      ) {
        next("/OrderHistory/all");
        return;
      } else if (
        to.path === "/allPrices" ||
        to.path === "/AllPrices" ||
        to.path === "/allPrices/" ||
        to.path === "/AllPrices/"
      ) {
        next("/AllPrices/ex-rack");
        return;
      } else {
        next();
        return;
      }
    }
  }
});

export default router;